import React from 'react';
import { Button } from '../ui/Button';
export function HeroSection() {
  const scrollToOffer = () => {
    document.getElementById('offer-section')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-20 pb-24 md:pt-32 md:pb-32 overflow-hidden bg-[#FCFCFA]" data-id="element-84">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-85">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-86">
          {/* Text Content */}
          <div className="max-w-2xl" data-id="element-87">
            <div className="inline-flex items-center space-x-2 mb-6" data-id="element-88">
              <span className="h-px w-8 bg-forest-600" data-id="element-89"></span>
              <span className="text-forest-700 font-medium tracking-widest uppercase text-sm" data-id="element-90">
                The 48-Hour Protocol
              </span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-medium leading-tight text-stone-900 mb-6 text-balance" data-id="element-91">
              Look Leaner and Feel Lighter by Friday.
            </h1>

            <p className="text-lg md:text-xl text-stone-600 mb-10 leading-relaxed" data-id="element-92">
              The emergency biological "flush" to erase bloating and reclaim
              your waistline in just two days—without starvation or expensive
              supplements.
            </p>

            <div className="flex flex-col sm:flex-row gap-4" data-id="element-93">
              <Button size="lg" href="https://thedailyedit.it.com/cart/47830899851456:1" className="group" data-id="element-94">
                Get The Reset Now
                <svg className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-95">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" data-id="element-96" />
                </svg>
              </Button>
            </div>

            <div className="mt-8 flex items-center space-x-4 text-sm text-stone-500" data-id="element-97">
              <div className="flex -space-x-2" data-id="element-98">
                {[1, 2, 3, 4].map(i => <div key={i} className="w-8 h-8 rounded-full bg-stone-200 border-2 border-white flex items-center justify-center overflow-hidden" data-id="element-99">
                    <img src={`https://i.pravatar.cc/100?img=${i + 10}`} alt="User" className="w-full h-full object-cover" data-id="element-100" />
                  </div>)}
              </div>
              <p data-id="element-101">
                Join{' '}
                <span className="font-semibold text-stone-700" data-id="element-102">2,400+</span>{' '}
                others who reset this week.
              </p>
            </div>
          </div>

          {/* Image */}
          <div className="relative lg:ml-auto w-full max-w-lg mx-auto lg:max-w-none" data-id="element-103">
            <div className="absolute inset-0 bg-forest-100 rounded-3xl transform rotate-3 scale-105 -z-10 transition-transform duration-700 hover:rotate-6" data-id="element-104"></div>
            <img src="https://cdn.magicpatterns.com/uploads/vV6bTtWhKGojY3xVMmoLhx/heylloyd-image-1774062337432.png" alt="48-Hour Gut Reset Planner on an iPad" className="w-full h-auto rounded-3xl shadow-editorial object-cover border border-stone-100" data-id="element-105" />
          </div>
        </div>
      </div>
    </section>;
}